import { Flex, Typography, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';

const { Text, Paragraph } = Typography;

function NotFound() {
  const [downloadAppModalVisible, setDownloadAppModalVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Flex vertical style={{ 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif'
    }}>
      <Navbar
        breadcrumbsVisible={false}
        headerDownloadButtonOnClick={() => setDownloadAppModalVisible(true)}
      />
      
      <Row 
        justify="space-between" 
        align="middle" 
        gutter={[32, 32]} 
        style={{
          flex: 1,
          padding: isMobile ? '1rem' : '2rem',
          paddingTop: isMobile ? '80px' : '20px', // Added to prevent overlap
          maxWidth: '80rem',
          margin: '0 auto',
          width: '100%'
        }}
      >
        <Col xs={24} md={14}>
          <div style={{ padding: '1rem' }}>
            <Text style={{
              fontSize: isMobile ? '1.2rem' : '1.5rem', // Adjusted for mobile
              display: 'block',
              marginBottom: '1.5rem',
              fontWeight: 400,
              lineHeight: 1.5
            }}>
              We couldn't find the page you were looking for. This is either because:
            </Text>
            
            <ul style={{
              paddingLeft: '1.5rem',
              marginBottom: '1.5rem',
              fontSize: isMobile ? '1rem' : '1.1rem', // Adjusted for mobile
              lineHeight: 1.6
            }}>
              <li style={{ marginBottom: '0.75rem' }}>
                There is an error in the URL entered into your web browser. Please check the URL and try again.
              </li>
              <li>
                The page you are looking for has been moved or deleted.
              </li>
            </ul>
            
            <Paragraph style={{ 
              fontSize: isMobile ? '1.2rem' : '1.5rem', // Adjusted for mobile
              marginBottom: 0
            }}>
              You can return to our homepage by{' '}
              <a href="/" style={{ color: '#fa5705' }}>clicking here</a>.
            </Paragraph>
          </div>
        </Col>
        <Col xs={24} md={10}>
          <div style={{ padding: '1rem', display: 'flex', justifyContent: 'center' }}>
            <img 
              src="https://img.icons8.com/?size=400&id=5KFA-RlyxCq0&format=png&color=000000" 
              alt="Broken robot" 
              style={{ 
                maxWidth: '100%', 
                height: 'auto',
                maxHeight: isMobile ? '200px' : '400px' // Adjusted for mobile
              }} 
            />
          </div>
        </Col>
      </Row>
    </Flex>
  );
}

export default NotFound;